import { useState } from "react";

import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import { postActiveCompanyRules } from "../../../../../MyApi/sb/companyrules";

import icons from "../../../../../Data/icons";
import classes from "../../../../../assets/css/showCardInfo.module.css"


const CompanyRulesDetalis = ({ showRules }) => {
  const {id,name , active} =showRules
  const [activeState, setActive] = useState(active);
  const mutation = useMutation(
    ["postActive", id],
    (postData) => postActiveCompanyRules(postData, id),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );
  const { t } = useTranslation();

  const handelChangeActive = (e) => {
    const isChecked = e.target.checked;
    const newActiveState = isChecked ? 1 : 0;

    setActive(newActiveState);
    mutation.mutate({
      active: newActiveState,
    });
  };

  const titles = {
    id: "#",
    name:t("Name"),
    currency: t("Currency"),
    phone: t("Phone-code"),
    symbol: t("Symbol"),

  };
  const IdCardIcon= icons.idCard
  const AbcIcon = icons.abc


  return (
    <div className={classes.container}>
    <div className={classes.tableCard}> 
    <div className={classes.tableCardBody}>
    <ul className={classes.ListGroup}>
     <li className={classes.listItemGroup}>
       <div className={classes.listIcon}>
        <IdCardIcon/>
       </div>
       <div>
         <h5 className={classes.listTitle}>{titles.id}</h5>
         <p>{id}</p>
       </div>
     </li>
     <li className={classes.listItemGroup}>
       <div className={classes.listIcon}>
      <AbcIcon/>
       </div>
       <div>
           <h5 className={classes.listTitle}>{titles.name}</h5>
       <p className={classes.listPargrah}>{name}</p>
       </div>
     </li>
     <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
              
              </div>
              <div>
                <h5 className={classes.listTitle}>
                  {" "}
                  {activeState === 1 ? " نشط" : "غير نشط"}
                </h5>
                <div className={classes.formCol}>
                  <label
                    htmlFor="active"
                    className={
                      activeState ? `${classes.active}` : `${classes.disActive}`
                    }>
                    {" "}
                  </label>

                  <label class="switch">
                    <input
                      type="checkbox"
                      onChange={handelChangeActive}
                      checked={activeState}
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </li>
   
   </ul>
    </div>

 </div>
</div>
  );
};

export default CompanyRulesDetalis;
